import { Injectable, Output, EventEmitter } from '@angular/core';
import { URLSearchParams, Http } from "@angular/http";
import {Observable} from  "rxjs/Observable";
import { HttpService } from './http-service';
import 'rxjs/add/operator/map';
import {LoadingService} from "./loading-service";
import {AuthStore} from '../stores/auth-store';

/*
  Generated class for the HttpReserveProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class HttpReserveProvider extends HttpService {
  @Output() onSaveReserve = new EventEmitter<Object>();
  constructor(
    protected http: Http,
    protected loadingService: LoadingService,
    protected authStore: AuthStore
  ) {
    super(http, loadingService, authStore);
  }

  /**
   * 記録登録処理
   */
  save(data: object): Observable<any> {
    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/reserves/save");
    var options = super.buildParam(userParam);

    return super.post(options, data).finally(() => {
      this.onSaveReserve.emit(data);
    });
  }

  /**
   * 問診票登録
   */
  saveInterviewSheet(data: object): Observable<any> {
    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/reserves/saveInterviewSheet");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }

  /**
   * 体調不良・怪我連絡登録取得
   */
  getNotebookData(condition: object): Observable<any> {
    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("condition", JSON.stringify(condition));
    userParam.set("api", "/reserves/getNotebookData");
    userParam.set("needLoading", condition["needLoading"]);
    var options = super.buildParam(userParam);

    return super.get(options);
  }

  /**
   * 体調不良・怪我連絡登録
   */
  saveNotebook(data: object): Observable<any> {
    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/reserves/saveNotebook");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }

  /**
   * 予約リスト取得
   */
  getList(condition: object): Observable<any> {
    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("condition", JSON.stringify(condition));
    userParam.set("api", "/reserves/getList");
    userParam.set("needLoading", condition["needLoading"]);
    var options = super.buildParam(userParam);

    return super.get(options);
  }

  /**
   * 問診票データ取得
   */
  getInterviewData(condition: object): Observable<any> {
    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("condition", JSON.stringify(condition));
    userParam.set("api", "/reserves/getInterviewData");
    userParam.set("needLoading", condition["needLoading"]);
    var options = super.buildParam(userParam);

    return super.get(options);
  }

  /**
   * 送迎情報取得
   */
  getPickupData(condition: object): Observable<any> {
    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("condition", JSON.stringify(condition));
    userParam.set("api", "/reserves/getPickupData");
    userParam.set("needLoading", condition["needLoading"]);
    var options = super.buildParam(userParam);

    return super.get(options);
  }

  /**
   * 写真リクエストへの返信
   */
  replyPhotoRequest(data) {
    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/reserves/replyPhotoRequest");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }

  /**
   * 写真リクエスト返信可能状態にする
   */
  toEnablePhotoRequestReply(data) {
    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/reserves/toEnablePhotoRequestReply");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }

  /**
   * 写真リクエスト・メッセージを更新する
   */
  updatePhotoRequestMessage(data) {
    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/reserves/updatePhotoRequestMessage");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }

  /**
   * status変更
   */
  changeStatus(data) {
    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/reserves/changeStatus");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }
}



// WEBPACK FOOTER //
// ./src/providers/http-reserve.ts